export default __webpack_public_path__ + "static/media/Kitchen400.915326e0.jpg";